import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20product%20display%20with%20soft%20natural%20lighting%20on%20light%20wooden%20surface%2C%20neutral%20beige%20and%20cream%20tones%2C%20editorial%20lifestyle%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20atmospheric%20mood%2C%20high%20end%20aesthetic%2C%20organic%20textures%2C%20elegant%20composition%20with%20subtle%20shadows%2C%20bright%20airy%20feel&width=1600&height=900&seq=hero-main-bg-2026&orientation=landscape"
          alt="ACBuy Spreadsheet product sourcing hub featuring verified supplier data and organized product categories for global buyers"
          title="ACBuy Spreadsheet Sourcing Hub"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 backdrop-blur-sm text-white text-xs font-semibold tracking-wide mb-6 whitespace-nowrap">
            #1 Trusted Sourcing Resource 2026
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            Discover the Most Trusted{" "}
            <span className="text-primary-300">ACBuy Spreadsheet</span>{" "}
            for Sourcing Products from China
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Find verified product lists, supplier data, and real-time updated{" "}
            <strong className="text-white font-semibold">acbuy spreadsheet</strong>{" "}
            resources used by thousands of global buyers every day.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Access Latest ACBuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-base font-semibold border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-cart-line"></i>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10">
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
              <span>Updated Daily</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
              <span>Verified Suppliers</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
              <span>Used Worldwide</span>
            </div>
            <div className="flex items-center gap-2 text-white/70 text-xs">
              <i className="ri-checkbox-circle-line text-primary-300 text-sm"></i>
              <span>2026 Latest Data</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}